import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminFeatureGuard, AuditFeatureGuard, AuthGuard, BuzinessCatalogFeatureGuard, IntegratorFeatureGuard, SystemFeatureGuard, WizardFeatureGuard } from '@core/guards';
import { ActionService } from '@core/services';
import { ShellController } from '@shell/services';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule),
    data: { animation: 'modulePage' }
  },
  {
    path: 'change-password/:activationCode',
    loadChildren: () => import('./pages/change-password/change-password.module').then(m => m.ChangePasswordModule),
    data: { animation: 'modulePage' }
  },
  {
    path: 'contact',
    loadChildren: () => import('./pages/contact/contact.module').then(m => m.ContactModule),
    data: { animation: 'modulePage' }
  },
  ShellController.childRoutes([
    {
      path: 'home',
      canActivate: [AuthGuard, ActionService],
      loadComponent: () => import('./modules/home/home.component').then(comp => comp.HomeComponent),
      data: { animation: 'modulePage' }
    },
    {
      path: 'data-search',
      canActivate: [AuthGuard, ActionService],
      loadChildren: () => import('./modules/data-search/data-search.module').then(m => m.DataSearchModule),
      data: { animation: 'modulePage' }
    },
    {
      path: 'business-catalog',
      canActivate: [AuthGuard, ActionService, BuzinessCatalogFeatureGuard],
      loadChildren: () => import('./modules/buziness-catalog/buziness-catalog.module').then(m => m.BuzinessCatalogModule),
      data: { animation: 'modulePage' }
    },
    {
      path: 'wizard',
      canActivate: [AuthGuard, WizardFeatureGuard],
      loadChildren: () => import('./modules/wizard/wizard.module').then(m => m.WizardModule),
      data: { animation: 'modulePage' }
    },
    {
      path: 'hubs',
      canActivate: [AuthGuard, ActionService],
      loadChildren: () => import('./modules/hubs/hubs.module').then(m => m.HubsModule),
      data: { animation: 'modulePage' }
    },
    {
      path: 'audit',
      canActivate: [AuthGuard, ActionService, AuditFeatureGuard],
      loadChildren: () => import('./modules/audit/audit.module').then(m => m.AuditModule),
      data: { animation: 'modulePage' }
    },
    {
      path: 'custom-integrator',
      canActivate: [AuthGuard, ActionService, IntegratorFeatureGuard],
      loadChildren: () => import('./modules/custom-integrator/custom-integrator.module').then(m => m.CustomIntegratorModule),
      data: { animation: 'modulePage' }
    },
    {
      path: 'administration',
      canActivate: [AuthGuard, ActionService, AdminFeatureGuard],
      loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule),
      data: { animation: 'modulePage' }
    },
    {
      path: 'design-system',
      canActivate: [AuthGuard, SystemFeatureGuard],
      loadComponent: () => import('./pages/design-system/design-system.component').then(m => m.DesignSystemComponent),
      data: { animation: 'modulePage' }
    },
    { path: '', redirectTo: '/home', pathMatch: 'full', data: { animation: 'modulePage' } }
  ]),
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'login',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(
    routes,
    {
      onSameUrlNavigation: 'reload',
      enableTracing: false
    }
  )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
